import { Injectable } from '@angular/core';
import { Router, UrlTree } from '@angular/router';
import { AuthService } from '@auth/auth.service';

@Injectable({
  providedIn: 'root',
})
export class NotAuthenticatedGuard {
  constructor(
    public authService: AuthService,
    public router: Router,
  ) {}

  async canActivate(): Promise<boolean | UrlTree> {
    if (!(await this.authService.checkAuthenticated())) {
      return true;
    }
    return this.router.createUrlTree(['/dashboard']);
  }
}
